<template>
  <div class="part-msg" :class="{'is-cur': isCur}">
    <div class="part-btn">
      <!-- <span class="tag" v-if="info.noStudy">选学</span> -->
      <a-tooltip v-if="info.name.length > 5" placement="top">
        <template slot="title">
          <span style="display: inline-block;max-width: 210px;">{{ info.name }}</span>
        </template>
        <p>{{ info.name }}</p>
      </a-tooltip>
      <p v-else>
        {{ info.name }}
      </p>
      <SvgIcon icon="play" />
    </div>
    <p class="part-time">
      <a-tooltip
        :placement="isShowLessColumn ? 'bottom' : 'right'"
        :auto-adjust-overflow="true"
        :get-popup-container="getPopupContainer"
        :visible="index === 0 && isShow && tipVisible && isUserVisible"
        overlay-class-name="xkh-tool-tip-blue"
      >
        {{ durationDesc }}
        <template slot="title">
          <p>视频加互动的总时长</p>
          <div class="tip-btn">
            <span @click="tipOk">知道了</span>
          </div>
        </template>
      </a-tooltip>
    </p>
  </div>
</template>
<script>
import { defineComponent, computed, ref } from 'vue-demi'
import { formatDuration } from '@/utils/index'
import SvgIcon from '@/components/SvgIcon.vue'
import { getUserId } from '@/utils/tools'
export default defineComponent({
  components: { SvgIcon },
  props: {
    isShowLessColumn: {
      type: Boolean,
      default: false
    },
    info: Object,
    isCur: Boolean,
    index: Number,
    isShow: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { root }) {
    const durationDesc = computed(() => {
      const durationInteraction = props.info.durationInteraction || 0
      return formatDuration(props.info.duration + durationInteraction)
    })
    const storageKey = computed(() => `videoTimeTip-${getUserId()}`)
    const tipVisible = ref(false)
    const isUserVisible = ref(root.$storage.get(storageKey.value) !== false)
    // 需要加个延时，否者位置会不对
    setTimeout(() => {
      tipVisible.value = true
    }, 1000)
    const tipOk = () => {
      tipVisible.value = false
      // 每个账号只弹一次
      root.$storage.set(storageKey.value, false)
      isUserVisible.value = false
    }
    const getPopupContainer = function(trigger) {
      return trigger.parentElement
    }
    return {
      getPopupContainer,
      durationDesc,
      tipVisible,
      tipOk,
      isUserVisible
    }
  }
})
</script>
<style lang="less" scoped>
.part-msg {
  color: #505873;
}
.part-btn {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 137px;
  background: #F0F2F4;
  border-radius: 8px;
  height: 38px;
  padding: 0 16px;
  box-sizing: border-box;
  border: 1px solid transparent;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  .tag {
    display: block;
    position: absolute;
    background: #FFF8E5;
    border-radius: 0px 0px 4px 4px;
    width: 53px;
    text-align: center;
    height: 18px;
    font-family: 'Microsoft YaHei UI';
    font-weight: 400;
    font-size: 12px;
    letter-spacing: 0.04em;
    color: #FF8800;
    transform: rotate(-45deg) scale(.83);
    top: 0;
    left: -17px;
  }
  p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 4px;
  }
}
.part-time {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-top: 4px;
  padding-left: 16px;
}
.is-cur {
  .part-btn {
    border-color: #3262FD;
  }
}
.tip-btn {
  margin-top: 18px;
  text-align: right;
  padding: 0 8px 2px 0;
  span {
    cursor: pointer;
  }
}
</style>